import styled from 'styled-components';

export const ImprintWrapper = styled.div`
  grid-area: metrics;
  padding: 14px 17px;
  border-radius: 4px;
  border: solid 1px #b7b7b7;
  background-color: #ffffff;
`;
